/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset
 */
export interface PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset
   */
  language: SingleTurnChatLanguageEnum;
}

/**
 * Check if a given object implements the PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset interface.
 */
export function instanceOfPerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset(
  value: object,
): value is PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function PerturbedDatasetPolymorphicPerturbedSingleTurnChatDatasetFromJSON(
  json: any,
): PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset {
  return PerturbedDatasetPolymorphicPerturbedSingleTurnChatDatasetFromJSONTyped(json, false);
}

export function PerturbedDatasetPolymorphicPerturbedSingleTurnChatDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
  };
}

export function PerturbedDatasetPolymorphicPerturbedSingleTurnChatDatasetToJSON(
  value?: Omit<PerturbedDatasetPolymorphicPerturbedSingleTurnChatDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
  };
}
